import React from 'react';
import PropTypes from 'prop-types';
import { Row } from './components/row';
import { Column } from './components/column';

const LayoutRow = ({
  elements, widths, id, className
}) => {
  const columns = elements.map((content, index) => {
    const key = `${id}-${index}`;
    return (
      <Column
        width={widths[index]}
        key={key}
      >
        {content}
      </Column>
    );
  });

  return (
    <Row className={className}>
      {columns}
    </Row>
  );
};

LayoutRow.propTypes = {
  elements: PropTypes.array.isRequired,
  widths: PropTypes.array.isRequired,
  id: PropTypes.string,
  className: PropTypes.string
};

LayoutRow.defaultProps = {
  className: undefined,
  id: undefined
};

export default LayoutRow;
